// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_OettH","tab":"index_tab_CIdzQ","tabSelected":"index_tabSelected_2ktSc","icon":"index_icon_RliWh"};